import { render, staticRenderFns } from "./promtBox.vue?vue&type=template&id=5370558c&scoped=true&"
import script from "./promtBox.vue?vue&type=script&lang=js&"
export * from "./promtBox.vue?vue&type=script&lang=js&"
import style0 from "./promtBox.vue?vue&type=style&index=0&id=5370558c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370558c",
  null
  
)

export default component.exports